<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        Password Reset
        <p/>
        <v-alert
                v-model="showAlert"
                :type="alertType">
            {{alertMessage}}
        </v-alert>
        <ValidationObserver ref="observer" v-slot="{ invalid }">
            <v-form>
                <v-progress-linear v-if="waiting" :indeterminate="true"/>
                <ValidationProvider
                        mode="aggressive"
                        rules="requiredPassword|minPassword:6|password:confirmation"
                        :debounce="300"
                        v-slot="{ errors }">
                    <v-text-field
                            type="password"
                            name="password"
                            :error-messages=errors[0]
                            label="New Password"
                            v-model="form.password"
                            solo
                            :disabled="waiting"/>
                </ValidationProvider>
                <ValidationProvider
                        vid="confirmation"
                        mode="aggressive"
                        rules="requiredPassword|minPassword:6"
                        :debounce="300"
                        v-slot="{ errors }">
                    <v-text-field
                            type="password"
                            name="password_confirmation"
                            :error-messages=errors[0]
                            label="Confirm the password"
                            v-model="form.password_confirmation"
                            solo
                            :disabled="waiting"/>
                </ValidationProvider>
                <v-btn
                        type="submit"
                        block
                        large
                        class="mb-3 primary"
                        @click="submit()"
                        :disabled="invalid || waiting">Submit
                </v-btn>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import { min, required } from 'vee-validate/dist/rules';
    import { verifyPasswordResetCode, confirmPasswordReset } from '@/firebase/firebase';

    extend('password',
    {
        validate: (value, { other }) => value === other,
        message: 'The password and confirmation password do not match.',
        params: [{ name: 'other', isTarget: true }]
    });
    extend('requiredPassword',
    {
        ...required,
        message: 'The password is required and must be at least 6 characters.'
    });
    extend('minPassword',
    {
        ...min,
        message: 'The password is required and must be at least 6 characters.'
    });

    export default
    {
        name: 'forgot-password',
        components:
        {
            ValidationProvider,
            ValidationObserver
        },
        data()
        {
            return {
                actionCode: '',
                form:
                {
                    password: '',
                    password_confirmation: ''
                },
                alertType: 'success',
                alertMessage: '',
                showAlert: false
            }
        },
        computed:
        {
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        async mounted()
        {
            this.actionCode = this.$route.query.oobCode;
            try
            {
                this.WAITING(true);
                await verifyPasswordResetCode(this.$firebaseAuth, this.actionCode)
            }
            catch (error)
            {
                this.alertType = 'error';
                this.alertMessage = 'This password reset action has expired. Please select forgot password again in the Reflex app to generate a new email.';
                this.showAlert = true
            }
            this.WAITING(false)
        },
        methods:
        {
            ...mapMutations('common', ['WAITING']),
            async submit()
            {
                try
                {
                    if (await this.$refs.observer.validate())
                    {
                        this.WAITING(true);
                        await confirmPasswordReset(this.$firebaseAuth, this.actionCode, this.form.password);
                        this.alertType = 'success';
                        // Password reset has been confirmed and new password updated
                        if (/iphone|ipod|ipad/i.test(navigator.userAgent.toLowerCase()))
                        {
                            this.alertMessage = 'Your password has been reset.';
                            setTimeout(() =>
                            {
                                window.location = 'brightlamp.reflex://'
                            }, 1000)
                        }
                        else
                        {
                            this.alertMessage = 'Password has been reset.'
                        }
                        this.showAlert = true
                    }
                }
                catch (error)
                {
                    this.alertType = 'error';
                    this.alertMessage = error;
                    this.showAlert = true;
                    this.form.password = '';
                    this.form.password_confirmation = '';
                    // You should call it on the next frame
                    window.requestAnimationFrame(() =>
                    {
                        this.$refs.observer.reset()
                    });
                }
                this.WAITING(false)
            }
        }
    };
</script>